import React, { useEffect, useState, useRef } from "react";


import agradar from "../assets/images/blog/agradar.png";
import ansiedade from "../assets/images/blog/ansiedade.jpg";
import autoestima from "../assets/images/blog/autoestima.jpg";
import evitasentir from "../assets/images/blog/evitasentir.jpg";
import falarpsicologo from "../assets/images/blog/falarpsicologo.jpg";
import inteligenciaartificial from "../assets/images/blog/inteligencia-artificial.png";
import relacao from "../assets/images/blog/relacao.png";
import relacionamentos from "../assets/images/blog/relacionamentos.jpg";
import saudemental from "../assets/images/blog/Saúde-Mental-Maternal.jpg";
import sinais from "../assets/images/blog/sinais.png";
import tristeza from "../assets/images/blog/tristeza.jpg";



import "../styles/blog.css";

const projects = [
  
  {
    img: inteligenciaartificial,
    title: "Por que a Inteligência Artificial não pode substituir a terapia com um psicólogo?",
    slug: "inteligencia-artificial",
  },
  {
    img: falarpsicologo,
    title: "Por que falar com um psicólogo é diferente de desabafar com um amigo?",
    slug: "falar-psicologo",
  },
  {
    img: relacao,
    title: "Por que não podemos tomar uma cerveja juntos?",
    slug: "relacao-psicologo",
  },
  {
    img: evitasentir,
    title: "Você evita sentir? Saiba como isso pode estar te adoecendo emocionalmente — e o que a terapia pode fazer por você",
    slug: "evita-sentir",
  },
  {
    img: agradar,
    title: "Você vive para agradar os outros? Entenda como isso te afasta de si mesmo — e como a terapia pode ajudar",
    slug: "agradar-os-outros",
  },
  {
    img: sinais,
    title: "8 sinais que indicam que talvez seja hora de começar a terapia",
    slug: "sinais",
  },
  {
    img: ansiedade,
    title: "Ansiedade: quando o alerta natural se transforma em sofrimento silencioso",
    slug: "ansiedade",
  },
  {
    img: autoestima,
    title: "Autoestima: mais do que gostar da própria imagem",
    slug: "autoestima",
  },
  {
    img: relacionamentos,
    title: "Relacionamentos: um espelho de como nos sentimos por dentro",
    slug: "relacionamentos",
  },
  {
    img: saudemental,
    title: "Saúde mental materna: quando o cuidado com o outro precisa começar por você",
    slug: "saudemental",
  },
  {
    img: tristeza,
    title: "Tristeza x Depressão: qual a diferença?",
    slug: "tristeza",
  }
];

const Blog = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleItems = 3;
  const intervalRef = useRef(null);

  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
    }, 5000);
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  const getVisibleProjects = () => {
    const items = [];
    for (let i = 0; i < visibleItems; i++) {
      items.push(projects[(currentIndex + i) % projects.length]);
    }
    return items;
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + projects.length) % projects.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
  };

  return (
    <section className="blog-section" id="blog">
      <div
        style={{
          background: "linear-gradient(to bottom, #21383f, #31535e)",
          padding: "50px 0",
          textAlign: "center",
          color: "white",
        }}
      >
        <h2 className="about-title-white">Blog</h2>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            overflow: "hidden",
            position: "relative",
          }}
          onMouseEnter={stopAutoSlide}
          onMouseLeave={startAutoSlide}
        >
          <button
            onClick={goToPrevious}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "#FAF9F7",
              borderRadius: "20px",
              color: "#000",
              border: "none",
              padding: "10px",
              cursor: "pointer",
              zIndex: 1,
            }}
          >
            &#8592;
          </button>

          <div
            style={{
              display: "flex",
              gap: "40px",
              transition: "transform 0.5s ease-in-out",
              padding: "20px 0",
              margin: "20px",
            }}
          >
            {getVisibleProjects().map((item, ind) => (
              <div
                key={ind}
                className="card-blog-hover"
                style={{
                  position: "relative",
                  width: "350px",
                  height: "500px",
                  borderRadius: "15px",
                  overflow: "hidden",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                  background: `url(${item.img}) center/cover no-repeat`,
                  color: "#000",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    width: "100%",
                    padding: "20px",
                    background: "#EDE7DF",
                    textAlign: "center",
                    height: "180px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <h3 style={{ fontSize: "20px", marginBottom: "10px" }}>{item.title}</h3>
                  <button
                    onClick={() => {
                      window.location.href = `/blog/${item.slug}`;
                    }}
                    style={{
                      marginTop: "10px",
                      padding: "10px 20px",
                      backgroundColor: "#21383f",
                      color: "#fff",
                      textDecoration: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      width: "fit-content",
                      margin: "0 auto",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Ler mais
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={goToNext}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "#FAF9F7",
              borderRadius: "20px",
              color: "#000",
              border: "none",
              padding: "10px",
              cursor: "pointer",
              zIndex: 1,
            }}
          >
            &#8594;
          </button>
        </div>
      </div>
    </section>
  );
};

export default Blog;
